import {i18nContainer, locationContainer, loginContainer, statusContainer, uploadContainer, utils, enumContainer} from '@wallaby-ui/core';
import {
  autoLayoutContainer,
  applicationContainer,
  fileContainer,
  filterAndSearchContainer,
  filteringContainer,
  listContainer,
  hierarchyContainer as searchHierarchyContainer,
  reportsContainer,
  agensContainer,
  numberRangeContainer,
  medicationsContainer,
} from '@wallaby-ui/document';
import {Reducer, ReducersMapObject} from 'redux';
import {RouterState} from 'redux-first-history';

const staticReducers = {
  ...reportsContainer.getReducers(),
  ...listContainer.getReducers('patient'),
  ...listContainer.getReducers('hai'),
  [autoLayoutContainer.AUTO_LAYOUT_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    autoLayoutContainer.reducer,
    (action) => (action.stateId ?? action.meta?.stateId) === autoLayoutContainer.AUTO_LAYOUT_REDUCER_STATE_ID
  ),
  [applicationContainer.APPLICATION_REDUCER_STATE_ID]: applicationContainer.applicationSlice.reducer,
  [enumContainer.ENUM_REDUCER_STATE_ID]: enumContainer.enumSlice.reducer,
  [fileContainer.FILE_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    fileContainer.reducer,
    (action) => (action.stateId ?? action.meta?.stateId) === fileContainer.FILE_REDUCER_STATE_ID
  ),
  [i18nContainer.I18N_REDUCER_STATE_ID]: i18nContainer.i18nSlice.reducer,
  [filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    filterAndSearchContainer.filterAndSearchSlice.reducer,
    (action) => action.stateId === filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_STATE_ID
  ),
  [filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_HIERARCHY_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    filterAndSearchContainer.filterAndSearchSlice.reducer,
    (action) => action.stateId === filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_HIERARCHY_STATE_ID
  ),
  [filteringContainer.FILTERING_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    filteringContainer.reducer,
    (action) => (action.stateId ?? action.meta?.stateId) === filteringContainer.FILTERING_REDUCER_STATE_ID
  ),
  [searchHierarchyContainer.HIERARCHY_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    searchHierarchyContainer.reducer,
    (action) => (action.stateId ?? action.meta?.stateId) === searchHierarchyContainer.HIERARCHY_REDUCER_STATE_ID
  ),
  [locationContainer.LOCATION_REDUCER_STATE_ID]: locationContainer.reducer,
  [loginContainer.LOGIN_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    loginContainer.reducer,
    (action) => (action.stateId ?? action.meta?.stateId) === loginContainer.LOGIN_REDUCER_STATE_ID
  ),
  [numberRangeContainer.NUMBER_RANGE_REDUCER_STATE_ID]: numberRangeContainer.numberRangeSlice.reducer,
  [medicationsContainer.MEDICATIONS_REDUCER_STATE_ID]: medicationsContainer.medicationsSlice.reducer,
  [agensContainer.AGENS_REDUCER_STATE_ID]: agensContainer.agensSlice.reducer,
  [statusContainer.STATUS_REDUCER_STATE_ID]: statusContainer.statusSlice.reducer,
  [uploadContainer.UPLOAD_REDUCER_STATE_ID]: utils.reducerUtils.createFilteredReducer(
    uploadContainer.reducer,
    (action) => (action.stateId ?? action.meta?.stateId) === uploadContainer.UPLOAD_REDUCER_STATE_ID
  ),
} as const;

const createReducer = (routerReducer: Reducer<RouterState>, asyncReducers: ReducersMapObject = {}) => ({
  // This is necessary for typescript to infer correct type (otherwise it just infer object with router property)
  // eslint-disable-next-line no-useless-computed-key
  ['router']: routerReducer,
  ...staticReducers,
  ...asyncReducers,
});

export default createReducer;
